var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Transition from '../transition';
import Notification from './notification';
import { StyledNotificationStack } from './style';
var seed = 0;
var now = Date.now();
function getUuid() {
    return "notification_" + now + "_" + seed++;
}
var NotificationStack = /** @class */ (function (_super) {
    __extends(NotificationStack, _super);
    function NotificationStack(props) {
        var _this = _super.call(this, props) || this;
        _this.add = function (notification) {
            var key = getUuid();
            _this.setState(function (previousState) {
                var notifications = previousState.notifications;
                var newNotification = __assign(__assign({}, notification), { key: key });
                notifications.push(newNotification);
                return { notifications: notifications };
            });
        };
        _this.close = function (args) {
            _this.setState(function (previousState) { return ({
                notifications: previousState.notifications.filter(function (notification) { return notification.key !== args.key; }),
            }); });
            if (args.onClose) {
                args.onClose();
            }
        };
        _this.state = {
            notifications: [],
        };
        return _this;
    }
    NotificationStack.prototype.render = function () {
        var _this = this;
        return (React.createElement(StyledNotificationStack, null,
            React.createElement(Transition.Group, { animation: 'fade up' }, this.state.notifications.map(function (args, index) { return (React.createElement("div", { key: args.key },
                React.createElement(Notification, __assign({}, args, { onClose: function () { return _this.close(args); } })))); }))));
    };
    return NotificationStack;
}(React.Component));
export default NotificationStack;
//# sourceMappingURL=notificationStack.js.map